import * as Yup from 'yup';
import { t } from 'src/lib/language';

const OrganisationContactValidator = (lang:string) => Yup.object().shape({
  website: Yup.string()
    .max(150, t(lang, 'validations.contact.field_maximum', { max: 150 })).nullable(),
  email: Yup.string()
    .max(150, t(lang, 'validations.contact.field_maximum', { max: 150 })),
  address: Yup.string()
    .max(150, t(lang, 'validations.contact.field_maximum', { max: 150 })),
  state: Yup.string()
    .max(150, t(lang, 'validations.contact.field_maximum', { max: 150 })),
  suite: Yup.string()
    .max(150, t(lang, 'validations.contact.field_maximum', { max: 150 })),
  zipCode: Yup.string()
    .max(7, t(lang, 'validations.contact.field_maximum', { max: 7 })),
  phone: Yup.number()
    .transform((value, originalValue) => (originalValue === '' ? null : value))
    .nullable(),
  extension: Yup.number()
    .transform((value, originalValue) => (originalValue === '' ? null : value))
    .nullable(),
  tollfreePhone: Yup.number()
    .transform((value, originalValue) => (originalValue === '' ? null : value))
    .nullable(),
  tollfreeExtension: Yup.number()
    .transform((value, originalValue) => (originalValue === '' ? null : value))
    .nullable(),
});

export default OrganisationContactValidator;
